import React from 'react';
import { Box, Stack, Typography, Divider } from '@mui/material';

const SectionHeader = ({ title, subtitle, icon }) => (
  <Box sx={{ mb: 4 }}>
    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 700 }}>
        {icon} {title}
      </Typography>
    </Stack>
    {subtitle && (
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    )}
    <Divider sx={{ mt: 2 }} />
  </Box>
);

export default SectionHeader;